let agGridLoaded = false

export async function loadAgGrid() {
  if (agGridLoaded) return true

  // 1️⃣ Load styles FIRST
  await Promise.all([
    import(
      /* webpackChunkName: "ag-grid" */
      'ag-grid-community/styles/ag-grid.css'
    ),
    import(
      /* webpackChunkName: "ag-grid" */
      'ag-grid-community/styles/ag-theme-quartz.css'
    )
  ])

  // 2️⃣ Load JS after styles
  const [{ LicenseManager }] = await Promise.all([
    import(
      /* webpackChunkName: "ag-grid" */
      'ag-grid-enterprise'
    )
  ])

  LicenseManager.setLicenseKey(
    process.env.VUE_APP_AG_GRID_LICENSE_KEY
  )

  agGridLoaded = true
  return true
}